import { render, staticRenderFns } from "./uploadImg.vue?vue&type=template&id=a0bc361e&scoped=true"
import script from "./uploadImg.vue?vue&type=script&lang=js"
export * from "./uploadImg.vue?vue&type=script&lang=js"
import style0 from "./uploadImg.vue?vue&type=style&index=0&id=a0bc361e&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0bc361e",
  null
  
)

export default component.exports